var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11189_22109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.24074 3.36723C7.28153 3.36696 6.34379 3.64925 5.54611 4.17841C4.74842 4.70757 4.12663 5.45982 3.75937 6.34003C3.3921 7.22025 3.29587 8.18887 3.48283 9.12342C3.6698 10.058 4.13156 10.9164 4.80972 11.5903C5.48788 12.2641 6.35198 12.7231 7.29274 12.909C8.23349 13.095 9.20864 12.9997 10.0949 12.6351C10.9811 12.2706 11.7386 11.6531 12.2715 10.8609C12.8044 10.0687 13.0889 9.13729 13.0889 8.18447C13.0874 6.90754 12.5762 5.68332 11.6673 4.78027C10.7585 3.87722 9.52622 3.36906 8.24074 3.36723ZM8.24074 1.5C9.5716 1.50027 10.8725 1.89254 11.9789 2.62721C13.0854 3.36187 13.9477 4.40594 14.4568 5.62739C14.9659 6.84884 15.099 8.19282 14.8391 9.48939C14.5793 10.786 13.9383 11.9769 12.9972 12.9116C12.056 13.8463 10.857 14.4828 9.55165 14.7406C8.24634 14.9984 6.89337 14.866 5.66384 14.36C4.43431 13.854 3.38342 12.9972 2.64406 11.898C1.9047 10.7988 1.51007 9.50647 1.51007 8.18447C1.51007 7.30653 1.68417 6.4372 2.02244 5.62612C2.3607 4.81503 2.8565 4.07808 3.48152 3.45735C4.10654 2.83662 4.84853 2.34427 5.66513 2.00843C6.48172 1.67258 7.35692 1.49982 8.24074 1.5Z",
    fill: "#565656",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6164 16.5C15.3688 16.5002 15.1301 16.408 14.9476 16.2417L11.6108 13.2296C11.4154 13.0532 11.2985 12.807 11.2858 12.545C11.2732 12.283 11.3658 12.0267 11.5434 11.8326C11.7209 11.6385 11.9688 11.5224 12.2326 11.5098C12.4963 11.4972 12.7543 11.5893 12.9497 11.7656L16.2865 14.7778C16.4351 14.9123 16.5393 15.0882 16.5854 15.2825C16.6315 15.4769 16.6174 15.6805 16.545 15.8668C16.4725 16.053 16.345 16.2131 16.1793 16.3261C16.0136 16.4392 15.8174 16.4998 15.6164 16.5Z",
    fill: "#565656",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11189_22109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.1019,
    height: 15,
    fill: "white",
    transform: "translate(1.51007 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.f2e69988c88d6cfe146b3a82c7da5707.svg";
export { ForwardRef as ReactComponent };